(function () {
    'use strict';
    angular.module('app').controller('BBAProfileDetailsController', BBAProfileDetailsController);

    BBAProfileDetailsController.$inject = [
        '$scope',
        '$q',
        'BBAProfileManagerService',
        'Carrier',
        '$timeout',
        '$routeParams',
        '$location',
        'toastr',
        'ConfirmationModalFactory',
        'ViewChangeNotificationFactory',
        'Units',
        '$rootScope',
        '$route',
        'CropperModalService',
        'Location'
    ];

    function BBAProfileDetailsController($scope,
        $q,
        BBAProfileManagerService,
        Carrier,
        $timeout,
        $routeParams,
        $location,
        toastr,
        ConfirmationModalFactory,
        ViewChangeNotificationFactory,
        Units,
        $rootScope,
        $route,
        CropperModalService,
        Location
    ) {
        let vm = this;

        vm.currentUser = $rootScope.GlobalProfile;
        vm.isViewMode = false;
        vm.resizeDimension = {width: 1200, height: 1200};

        const cropperModal = new CropperModalService();
        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const toInactiveConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const toActiveConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const onRouteChange = $scope.$on('$routeChangeStart', function (event, next) {
            if (!vm.isViewMode && isChanged(vm.profile, vm.profileRaw)) {
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChange();
                        let nextRoute = next.$$route.originalPath;
                        if (_.contains(next.$$route.originalPath, ':')) {
                            nextRoute = nextRoute.split(':')[0];
                        }
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        });

        vm.shipByTypeOptions = [
            {value: 'schedule', name: 'Schedule'},
            {value: 'min_capacity_cut_off', name: 'Min Capacity Cut-off'},
            {value: 'max_capacity_cut_off', name: 'Max Capacity Cut-off'}
        ];

        vm.carrierProviderOptions = [
            {value: 'first_mile', text: 'First Mile', viewName: 'firstMileCarrier'},
            {value: 'last_mile', text: 'Last Mile', viewName: 'lastMileCarrier'}
        ];

        vm.crossdockShipmentMilestoneOptions = [
            {value:'All',text:'All'},
            {value: 'first_mile', text: 'First Mile', viewName: 'firstMileCarrier'},
            {value: 'last_mile', text: 'Last Mile', viewName: 'lastMileCarrier'}
        ];

        vm.manifestDocumentTypes = [
            {value: 'DEFAULT', text: 'Default', viewName: 'default'},
            {value: 'FIRST_MILE', text: 'First Mile', viewName: 'firstMile'},
            {value: 'LAST_MILE', text: 'Last Mile', viewName: 'lastMile'},
            {value: 'ALL', text: 'All', viewName: 'all'}
        ];

        vm.enableCarrierLabelGenerationOption = [
            {value: 'ALL', text: 'All'},
            {value: 'FIRST_MILE', text: 'First Mile'},
            {value: 'LAST_MILE', text: 'Last Mile'}
        ];

        vm.steps = [
            {
                label: 'Profile Attributes',
                viewName: 'profileAttributes',
                templateUrl: '/templates/pages/bba-profile-manager/bba-profile-details/BPD-profile-attribute.html',
                form: {},
                validateFn: () => true,
                isValid: true,
                isActive: true
            },
            {
                label: 'First Mile Configuration',
                header: 'First Mile',
                postcodeLabel: 'Origin',
                viewName: 'firstMileCarrier',
                warehouseName: 'destination',
                postcodesField: 'origin',
                packages:'package',
                templateUrl: '/templates/pages/bba-profile-manager/bba-profile-details/BPD-mile-configuration.html',
                form: {},
                validateFn: (step) => {
                    step.form.$setSubmitted();
                    step.isValid =
                        vm.profile.mergeCarrier && step.viewName !== vm.profile.carrierProvider.viewName ||
                        step.details.active === false || step.details.serviceProfile != null || step.details.packages != null;
                    return step.isValid;
                },
                isValid: true
            },
            {
                label: 'Line Haul Configuration',
                viewName: 'lineHaulProvider',
                warehouseName: 'breakBulkWarehouse',
                templateUrl: '/templates/pages/bba-profile-manager/bba-profile-details/BPD-line-haul-configuration.html',
                form: {},
                validateFn: () => true,
                isValid: true
            },
            {
                label: 'Last Mile Configuration',
                header: 'Last Mile',
                postcodeLabel: 'Destination',
                viewName: 'lastMileCarrier',
                warehouseName: 'origin',
                postcodesField: 'destination',
                templateUrl: '/templates/pages/bba-profile-manager/bba-profile-details/BPD-mile-configuration.html',
                form: {},
                validateFn: (step) => {
                    step.isValid =
                        vm.profile.mergeCarrier && step.viewName !== vm.profile.carrierProvider.viewName ||
                        step.details.serviceProfile != null;
                    return step.isValid;
                },
                isValid: true
            }
        ];
        vm.profile = {};
        vm.carrierProviderChanged = carrierProviderChanged;
        vm.searchCarrierProfiles = searchCarrierProfiles;
        vm.setActiveStep = setActiveStep;
        vm.saveDetails = saveDetails;
        vm.changeStatus = changeStatus;
        vm.openCropper = openCropper;
        vm.onCarrieProfileChanged = onCarrieProfileChanged;

        init();

        function init() {
            getAllCountries();

            if ($routeParams.id && $routeParams.id !== 'add') {
                initAddForm();
                return;
            }

            initProfile();
        }

        function getAllCountries() {
            Location.Country({}, success => {
                vm.countries = success;
            }, error => {
                toastr.error(error.message, 'Error');
            });
        }

        function initAddForm() {
            vm.isFetching = true;
            vm.id = $routeParams.id;
            getBBAProfile($routeParams.id).then(data => {
                vm.steps.forEach(step => step.isActive = false);
                vm.steps.unshift({
                    label: 'Profile Summary',
                    templateUrl: '/templates/pages/bba-profile-manager/bba-profile-details/BPD-profile-summary.html',
                    form: {},
                    validateFn: () => true,
                    isValid: true,
                    isActive: true
                });
                Carrier.getServiceProfiles(function (carrierProfileData) {
                    vm.carrierProfileId = carrierProfileData && carrierProfileData.content && carrierProfileData.content[0] && carrierProfileData.content[0].carrierProfile.id || null;
                    initProfile(data);
                }, function (error) {
                    console.log(error);
                }, {
                    bbaProfileId: data.id
                });
            }).finally(() => {
                vm.isFetching = false;
            });
        }

        function getBBAProfile(id) {
            const defer = $q.defer();
            BBAProfileManagerService.get(function (result) {
                defer.resolve(result);
            }, err => {
                defer.reject(err.message);
                toastr.error('Unable to fetch BBA Profile', err.message);
            }, id);
            return defer.promise;
        }

        function initProfile(data = {}) {
            vm.firstMileCarrierRaw = angular.copy(data.firstMileCarrier);
            vm.lastMileCarrierRaw = angular.copy(data.lastMileCarrier);

            const firstMileCarrier = data.firstMileCarrier || {};
            const lineHaulProvider = data.lineHaulProvider || {};
            const lastMileCarrier = data.lastMileCarrier || {};

            const fmSourceStates = data.fmSourceStates || [];
            const lmDestinationStates = data.lmDestinationStates || [];

            const profile = {
                id: data.id || undefined,
                name: data.name || '',
                displayName: data.displayName || '',
                isInternational: data.localeSelection === 'international',
                generateGS1Label: !!data.generateGS1Label,
                carrierLabelType: data.carrierLabelType,
                crossdockShipmentMilestone: data.crossdockShipmentMilestone,
                active: data.active || false,
                mergeCarrier: data.mergeCarrier || false,
                carrierProvider: data.carrierProvider || 'first_mile',
                insuranceAmount: data.insuranceAmount || 0,
                logoUrl: data.logoUrl,
                firstMileCarrier: {
                    active: firstMileCarrier.active || false,
                    origins: firstMileCarrier.origins || []
                },
                lineHaulProvider: {
                    active: lineHaulProvider.active || false,
                    length: lineHaulProvider.length || null,
                    width: lineHaulProvider.width || null,
                    height: lineHaulProvider.height || null,
                    weight: lineHaulProvider.weight || null,
                    minCapacity: lineHaulProvider.minCapacity || null,
                    maxCapacity: lineHaulProvider.maxCapacity || null,
                    cost: lineHaulProvider.cost || null,
                    eta: lineHaulProvider.eta || null,
                    transportType: lineHaulProvider.transportType || 'air',
                    shipByType: lineHaulProvider.shipByType || 'schedule',
                    shippingSchedules: lineHaulProvider.shippingSchedules || [],
                    measureUnit: lineHaulProvider.measureUnit || $rootScope.GlobalProfile.office.measureUnit,
                    weightUnit: lineHaulProvider.weightUnit || $rootScope.GlobalProfile.office.weightUnit,
                },
                lastMileCarrier: {
                    destinations: lastMileCarrier.destinations || [],
                }
            };

            profile.carrierProvider = vm.carrierProviderOptions.find(carrierProvider => {
                return carrierProvider.value === profile.carrierProvider;
            });

            if (angular.getObjVal(data, 'crossdockShipmentMilestone')) {
                profile.crossdockShipmentMilestone = vm.crossdockShipmentMilestoneOptions.find(crossdockShipmentMilestoneOptions => crossdockShipmentMilestoneOptions.value === profile.crossdockShipmentMilestone);
            } else {
                profile.crossdockShipmentMilestone = vm.crossdockShipmentMilestoneOptions[0]
            }

            if(angular.getObjVal(data, 'manifestDocumentType')) {
                profile.manifestDocumentType = vm.manifestDocumentTypes.find(manifestDocumentType => {
                    return manifestDocumentType.value === data.manifestDocumentType.toUpperCase();
                });
            } else {
                profile.manifestDocumentType = vm.manifestDocumentTypes[0];
            }

            if (angular.getObjVal(data, 'carrierLabelType')) {
                profile.carrierLabelType = vm.enableCarrierLabelGenerationOption.find(labelType => labelType.value.toUpperCase() === data.carrierLabelType.toUpperCase());
            } else {
                profile.carrierLabelType = vm.enableCarrierLabelGenerationOption[0];
            }

            profile.lineHaulProvider.shipByType = vm.shipByTypeOptions.find(shipBy => {
                return shipBy.value === profile.lineHaulProvider.shipByType;
            });

            const {shippingSchedules} = profile.lineHaulProvider;
            if (!shippingSchedules.length) {
                shippingSchedules.push({
                    sunday: false,
                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                    pickupTime: '00:00:00'
                });
            }
            shippingSchedules[0].pickupTime = new Date('Jan 1, 2018 ' + shippingSchedules[0].pickupTime);

            setDetails('firstMileCarrier', 'destination', 'serviceProfile');
            setDetails('lineHaulProvider', 'breakBulkWarehouse', 'carrierProfile');
            setDetails('lastMileCarrier', 'origin', 'serviceProfile');

            function setDetails(providerName, warehouseName, serviceCarrierProfile) {
                const provider = data[providerName] || {};
                const warehouse = provider[warehouseName] || provider.office || {};
                const officeType = warehouse.officeType || provider.office && provider.office.officeType || 'custom';
                profile[providerName] = angular.extend(profile[providerName], {
                  
                    id: provider.id || undefined,
                    name: provider.name || '',
                    company: provider.company || null,
                    office: provider.office || {
                        name: 'Custom',
                        custom: true
                    },
                    overrideQuoting: provider.overrideQuoting,
                    overrideQuoteAmount: provider.overrideQuoteAmount,
                    transitTimeLatest: provider.transitTimeLatest,
                    transitTimeEarliest: provider.transitTimeEarliest,
                    perQtyAmount: provider.perQtyAmount,
                    goodsCheck:provider.goodsCheck || {},
                    [serviceCarrierProfile]: provider[serviceCarrierProfile] || null,
                    [warehouseName]: {
                        name: warehouse.name || 'Custom',
                        firstName: warehouse.firstName || '',
                        lastName: warehouse.lastName || '',
                        phone1: warehouse.phone1 || '',
                        phone2: warehouse.phone2 || '',
                        address1: warehouse.address1 || warehouse.addressLine1 || '',
                        address2: warehouse.address2 || warehouse.addressLine2 || '',
                        location: warehouse.location || null,
                        officeType: officeType.toLowerCase(),
                        code: warehouse.code || '',
                        countries: vm.countries,
                        email: warehouse.email,
                        states: setStates(providerName) // todo: make this dynamic
                    }
                });
            }

            function setStates(providerName) {
                if (providerName === 'firstMileCarrier') {
                    return fmSourceStates;
                }

                if (providerName === 'lastMileCarrier') {
                    return lmDestinationStates;
                }

                return null;
            }

            vm.initFlag = false;

            vm.profile = angular.copy(profile);
            vm.profileRaw = angular.copy(vm.profile);
            vm.units = Units;

            vm.measureUnit = Units.getMeasureUnit(profile.lineHaulProvider.measureUnit);
            vm.weightUnit = Units.getWeightUnit(profile.lineHaulProvider.weightUnit);
            vm.steps.forEach(step => {
                step.details = step.warehouseName ? vm.profile[step.viewName] : null;
            });

            getLastMileCustomsManifestSettings(lastMileCarrier.customsManifestConfig);

            $timeout(() => {
                vm.initFlag = true;
            });
        }

        function onCarrieProfileChanged() {
            getLastMileCustomsManifestSettings(angular.getObjVal(vm.lastMileCarrierRaw, 'customsManifestConfig'));
        }

        function getFirstMileCustomsManifestSettings(defaultValues) {
            const carrierId = getCarrierId(angular.getObjVal(vm.profile, 'firstMileCarrier.serviceProfile.carrierProfile'));
            if (carrierId) {
                BBAProfileManagerService.getCustomsManifestSettings(carrierId, data => {
                    if (data.length < 1) {
                        vm.profile.firstMileCarrier.customsManifestSettings = null;
                        return;
                    };
                    vm.profile.firstMileCarrier.customsManifestSettings = setCustomsManifestSettingsDefaultValue(defaultValues, data);
                }, error => {
                    console.log(error);
                });
            }
        }

        function getLastMileCustomsManifestSettings(defaultValues) {
            const carrierId = getCarrierId(angular.getObjVal(vm.profile, 'lastMileCarrier.serviceProfile.carrierProfile'));
            BBAProfileManagerService.getCustomsManifestSettings(carrierId, data => {
                if (data.length < 1) {
                    vm.profile.lastMileCarrier.customsManifestSettings = null;
                    return;
                };
                vm.profile.lastMileCarrier.customsManifestSettings = setCustomsManifestSettingsDefaultValue(defaultValues, data);
            }, error => {
                console.log(error);
            });
        }

        function setCustomsManifestSettingsDefaultValue(defaultValues, settings) {
            if (defaultValues) {
                settings.enabled = defaultValues.enabled;
                settings.forEach(d => {
                    const fieldName = d.name;
                    const foundValue = defaultValues.settings.find(val => val.name === fieldName);
                    if (foundValue) {
                        d.id = foundValue.id;
                        d.value = d.type === 'Number' ? Number(foundValue.value) : foundValue.value;
                    }
                });
            }
            return settings;
        }

        function getCarrierId(carrierProfile) {
            return angular.getObjVal(carrierProfile, 'carrier.id') || angular.getObjVal(carrierProfile, 'carrierId');
        }

        function carrierProviderChanged() {
            $timeout(() => {
                if (vm.profile.mergeCarrier && vm.profile.carrierProvider.value === 'first_mile') {
                    if (!vm.profile.firstMileCarrier.active) {
                        vm.profile.firstMileCarrier.active = true;
                        toastr.info('', 'First Mile Carrier enabled');
                    }
                }
            });
        }

        function changeStatus(evt) {
            evt.preventDefault();
            if (vm.profile.active) {
                vm.profile.active = false;
                toActiveConf.getInstance().result.then(function (cond) {
                    if (cond) vm.profile.active = true;
                });
                return false;
            }
            vm.profile.active = true;
            toInactiveConf.getInstance().result.then(function (cond) {
                if (cond) vm.profile.active = false;
            });
        }

        function isChanged(o, n) {
            return !angular.equals(cleanPayload(o), cleanPayload(n));
        }

        function cleanPayload(data) {
            const profile = angular.copy(data);
            const { firstMileCarrier, lineHaulProvider, lastMileCarrier } = profile;
            const { destination } = firstMileCarrier;
            const { breakBulkWarehouse } = lineHaulProvider;
            const { origin } = lastMileCarrier;

            if (profile.crossdockShipmentMilestone) {
                profile.crossdockShipmentMilestone = profile.crossdockShipmentMilestone.value
            }

            profile.carrierLabelType = profile.carrierLabelType ? profile.carrierLabelType.value : null;
            profile.manifestDocumentType = profile.manifestDocumentType.value.toLowerCase();
            profile.localeSelection = profile.isInternational ? 'international' : 'domestic';
            delete profile.isInternational;

            profile.lineHaulProvider.shipByType = profile.lineHaulProvider.shipByType.value;

            const schedule = profile.lineHaulProvider.shippingSchedules[0];
            const hour = ('0' + schedule.pickupTime.getHours()).split('').splice(-2).join('');
            const minute = ('0' + schedule.pickupTime.getMinutes()).split('').splice(-2).join('');
            const second = ('0' + schedule.pickupTime.getSeconds()).split('').splice(-2).join('');
            schedule.pickupTime = hour + ':' + minute + ':' + second;

            profile.carrierProvider = profile.carrierProvider.value;

            if (profile.mergeCarrier) {
                const provider = profile.carrierProvider === 'first_mile' ? firstMileCarrier : lastMileCarrier;
                firstMileCarrier.serviceProfile = provider.serviceProfile;
                lastMileCarrier.serviceProfile = provider.serviceProfile;
                lineHaulProvider.carrierProfile = provider.serviceProfile.carrierProfile;
            }

            firstMileCarrier.destination = cleanAddressData(firstMileCarrier.destination);
            lastMileCarrier.origin = cleanAddressData(lastMileCarrier.origin);
            lineHaulProvider.breakBulkWarehouse = cleanAddressData(lineHaulProvider.breakBulkWarehouse);

            convertIds(firstMileCarrier, destination, 'serviceProfile', 'origin');
            convertIds(lineHaulProvider, breakBulkWarehouse, 'carrierProfile');
            convertIds(lastMileCarrier, origin, 'serviceProfile', 'destination');



            if (!profile.firstMileCarrier.active) {
                profile.firstMileCarrier = {
                    name: firstMileCarrier.name,
                    active: false
                }
            }

            if (!profile.lineHaulProvider.active) {
                profile.lineHaulProvider = {
                    name: lineHaulProvider.name,
                    active: false
                }
            }

            profile.fmSourceStates = angular.getObjVal(firstMileCarrier, 'destination.states') || [];
            profile.lmDestinationStates = angular.getObjVal(lastMileCarrier, 'origin.states') || [];


            profile.lastMileCarrier.customsManifestConfig = getLastMileCustomsSettings();
            delete profile.firstMileCarrier.customsManifestSettings;
            delete profile.lastMileCarrier.customsManifestSettings;

            return profile;

            function getLastMileCustomsSettings() {
                if (angular.getObjVal(vm.profile, 'lastMileCarrier.customsManifestSettings.paramData')) {
                    const settings = vm.profile.lastMileCarrier.customsManifestSettings;
                    return getSettingsValue(settings);
                }
            }

            function getSettingsValue(customsManifestSettings) {
                const settingsData = {
                    enabled: customsManifestSettings.enabled || false,
                    settings: []
                };

                const settings = customsManifestSettings.paramData;
                const settingsName = Object.keys(settings);

                settingsName.forEach(setting => {
                    const foundSetting = customsManifestSettings.find(s => s.name === setting);
                    settingsData.settings.push({
                        id: foundSetting ? foundSetting.id : null,
                        name: setting,
                        value: settings[setting]
                    });
                });
                return settingsData;
            }

            function convertIds(obj, warehouse, serviceCarrierProfile, postcodesField) {
                obj.companyId = obj.company && obj.company.id || null;
                obj.officeId = obj.office && obj.office.id || null;
                obj[serviceCarrierProfile + 'Id'] = obj[serviceCarrierProfile] && obj[serviceCarrierProfile].id || null;

                delete obj.company;
                delete obj.office;
                delete obj[serviceCarrierProfile];

                warehouse.locationId = warehouse.location && warehouse.location.id || null;
                delete warehouse.location;

                if (warehouse.officeType === 'custom') {
                    warehouse.name = 'Custom';
                    warehouse.officeType = null;
                }

                if (postcodesField) {
                    obj[postcodesField + 'Ids'] = obj[postcodesField + 's'].map(postcode => postcode.id);
                    delete obj[postcodesField + 's'];
                }
            }

            function cleanAddressData(data) {
                data.address2 = data.address2 || null;
                data.phone2 = data.phone2 || null;
                return data;
            }
        }

        function searchCarrierProfiles(select) {
            if (!select.open)
                return false;
            vm.searching = true;
            vm.carrierProfiles = [];
            Carrier.getExternalCarrierProfiles(data => {
                vm.carrierProfiles = data.content;
                vm.searching = false;
            }, error => {
                vm.searching = true;
                toastr.error('Unable to search for carrier profiles', error.message);
            }, {
                name: select.search
            });
        }

        function setActiveStep(step, opts = {}) {
            opts && opts.form && opts.form.$setSubmitted();
            angular.forEach(vm.steps, item => {
                if (item.isActive) {
                    item.form.$setSubmitted && item.form.$setSubmitted();
                    item.validateFn(item);
                }
                item.isActive = false;
            });
            if (opts.validate) {
                if (opts.form.$invalid && opts.form.$submitted) {
                    return false;
                }
            }
            if (!step) {
                $location.path('/bba-profile-manager');
                return false;
            }
            step.isActive = true;
        }

        function saveDetails() {
            const complete = vm.steps.every(step => {
                step.form.$setSubmitted && step.form.$setSubmitted();
                if (step.form.$invalid || !step.validateFn(step)) {
                    setActiveStep(step);
                    return false;
                }
                return true;
            });
            if (!complete) {
                return false;
            }
            vm.saveInProgress = true;
            const profile = cleanPayload(vm.profile);
            const profileRaw = cleanPayload(vm.profileRaw);

            // todo: need to fix this one here
            if (profile.mergeCarrier && profile.carrierProvider === 'first_mile') {
                profile.lastMileCarrier.destinationIds = profileRaw.lastMileCarrier.destinationIds;

            } else if (profile.mergeCarrier && profile.carrierProvider === 'last_mile') {
                profile.firstMileCarrier.originIds = profileRaw.firstMileCarrier.originIds;
            }

            if (vm.id) {
                BBAProfileManagerService.update(vm.id, profile, data => {
                    vm.saveInProgress = false;
                    toastr.success('Data successfully updated');
                    if(vm.profilePhoto) {
                        uploadLogo(vm.profilePhoto, vm.id);
                    }
                    initProfile(data);
                }, errorCallback)
            } else {
                BBAProfileManagerService.create(profile, result => {
                    onRouteChange();
                    if(vm.profilePhoto) {
                        uploadLogo(vm.profilePhoto, result.id).then(() => {
                            $location.path('/bba-profile-manager/' + result.id);
                            toastr.success('Data successfully created');
                        });
                    } else {
                        $location.path('/bba-profile-manager/' + result.id);
                        toastr.success('Data successfully created');
                    }
                }, errorCallback)
            }

            function errorCallback(err) {
                vm.saveInProgress = false;
                toastr.error(err.message);
            }
        }

        function uploadLogo(file, profileId) {
            const defer = $q.defer();
            vm.profilePhotoUploading = true;
            BBAProfileManagerService.uploadLogo(file, profileId, result => {
                vm.profilePhotoUploading = false;
                toastr.success('Logo successfully updated');
                defer.resolve();
            }, error => {
                vm.profilePhotoUploading = false;
                toastr.error(error.message);
                defer.reject();
            });
            return defer.promise;
        }

        function openCropper(load, fieldName) {
            cropperModal.setImageFile(load);
            cropperModal.getInstance().result.then(newImage => {
                vm[fieldName] = cropperModal.dataURItoBlob(newImage, load.$ngfName);
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/bba-profile-manager/BBAProfileDetailsController.js